import React from "react";
import moment from "moment";
import DatePickers from "./DatePickers";
import MedSelector from "./MedSelector";
import ClientSelector from "./ClientSelector";
import FacilitySelector from "./FacilitySelector";
import { formatClientOption } from "./helpers";

class Filter extends React.Component {
  constructor(props) {
    super(props);
    const { facilities, clients, medications } = props;

    function currentClient() {
      let client = clients.filter(
        (resident) => resident.id == props.clientId
      )[0];
      return formatClientOption(client);
    }

    let currentMedication = props.medicationName && {
      value: props.medicationName,
      label: props.medicationName,
    };

    this.state = {
      facilityId: props.facilityId && {
        value: props.facilityId,
        label: facilities.filter(
          (facility) => facility.id == props.facilityId
        )[0].name,
      },
      clientId: props.clientId && currentClient(),
      medId: currentMedication,
      startDate: props.startDate && moment(props.startDate),
      endDate: props.endDate && moment(props.endDate),
      clients: clients,
      medications: medications,
    };
  }

  submitForm(format) {
    // put values from state into a readible object that breaks them out form the selector structure they are in
    var variables = {};
    for (var property in this.state) {
      if (this.state[property] == undefined) {
        variables[property] = "";
      } else {
        variables[property] = this.state[property];
      }
    }

    // format values into a uri that is formatted for ransacker
    let groupId = `?q[occupancies_group_id_eq]=${
      variables.facilityId.value || ""
    }`;
    let residentId = `&q[resident_id_eq]=${variables.clientId.value || ""}`;
    let medicationName = `&q[details_name_cont]=${variables.medId.value || ""}`;
    let startDate = `&q[created_at_gteq]=${
      variables.startDate
        ? moment(variables.startDate).format("YYYY-MM-DD")
        : ""
    }`;
    let endDate = `&q[created_at_lteq]=${
      variables.endDate ? moment(variables.endDate).format("YYYY-MM-DD") : ""
    }`;
    var url = "";
    if (format === "csv") {
      if (this.props.isStaffApp)
        url = `medication_log_entries/export_csv${
          format ? `.${format}` : ""
        }${groupId}${residentId}${medicationName}${startDate}${
          endDate || ""
        }&HTTP_STAFF_APP=true`;
      else
        url = `medication_log_entries/export_csv${
          format ? `.${format}` : ""
        }${groupId}${residentId}${medicationName}${startDate}${endDate || ""}`;
      // redirect to search results
      Turbo.visit(encodeURI(url));
    } else {
      url = `medication_log_entries${groupId}${residentId}${medicationName}${startDate}${
        endDate || ""
      }`;
      Turbo.visit(encodeURI(url));
    }
  }

  render() {
    const {
      facilityId,
      clientId,
      medId,
      startDate,
      endDate,
      clients,
      medications,
      clientsIsLoading,
      medicationsIsLoading,
    } = this.state;
    const { facilities, canExportCSV } = this.props;

    return (
      <div className="App p-3">
        <div className="row">
          <FacilitySelector
            value={facilityId}
            setParentState={(value) =>
              this.setState(() => {
                return value;
              })
            }
            facilities={facilities}
          />
          {(
            <ClientSelector
              value={clientId}
              setParentState={(value) =>
                this.setState(() => {
                  return value;
                })
              }
              isLoading={clientsIsLoading}
              clients={clients}
            />
          )}
          {!!facilityId && !!clientId && (
            <MedSelector
              value={medId}
              setParentState={(value) =>
                this.setState(() => {
                  return value;
                })
              }
              isLoading={medicationsIsLoading}
              medications={medications}
            />
          )}
        </div>
        <div className="row">
          <DatePickers
            startDate={startDate}
            endDate={endDate}
            setStartDate={(date) =>
              this.setState(() => {
                return { startDate: date };
              })
            }
            setEndDate={(date) =>
              this.setState(() => {
                return { endDate: date };
              })
            }
          />
          <button
            className="btn btn-sm btn-info ml-3 mt-2 ml-0 d-inline-block"
            style={{ borderRadius: 4 }}
            onClick={() => this.submitForm()}
          >
            Filter
          </button>
          {canExportCSV && (
            <button
              className="btn btn-sm btn-info ml-2 mt-2 ml-0 d-inline-block"
              style={{ borderRadius: 4 }}
              onClick={() => this.submitForm("csv")}
            >
              Export CSV*
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default Filter;
